module.exports = __webpack_public_path__ + "index/img/zhangdan.dbba45a4.png";